import { render, staticRenderFns } from "./KoioteMomentaneo.vue?vue&type=template&id=bab8928e&lang=es&"
import script from "./KoioteMomentaneo.vue?vue&type=script&lang=js&"
export * from "./KoioteMomentaneo.vue?vue&type=script&lang=js&"
import style0 from "./KoioteMomentaneo.vue?vue&type=style&index=0&id=bab8928e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports